export enum FormEvents {
  START = 'form.start',
  STEP = 'form.step',
  COMPLETE = 'form.complete',
  JEOPARDY = 'form.jeopardy',
  RESPONSE = 'form.response',
  REQUEST = 'form.request',
  SEARCH_REGISTRATION = 'search.registration',
  PAYMENT_ATTEMPT = 'payAttempt',
  CROSS_SELL_CLICK = 'crossSellClick',
  CHAT_STARTED = 'form.chatstarted',
  FORM_SUBMIT = 'form.submit',
  PREMIUM_CHANGE = 'premium.change',
  INLINE_ERROR = 'form.inLineError',
  DIRECTDEBIT_CLICK = 'directDebitClick',
  LOGIN_START = 'login.start',
  LOGIN_COMPLETE = 'login.complete',
  INTERACTION_LINK_CLICK = 'interaction.linkClick',
}
